import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { PerimetersService } from './perimeters.service';

import { APIService, KPI } from '../../@core/api';
import { UtilsService } from './utils.service';

@Injectable()
export class RoadmapService {

  private _chapters$: Observable<KPI.Chapter[]>;
  private items: { [chapter_id: number]: Observable<KPI.Item[]> } = {};

  constructor(
    private api: APIService,
  ) { }

  private _roadmapIndicators$: { [key: string]: Observable<KPI.RoadmapIndicator[]> } = {};
  public roadmapIndicators(
    perimeters?: KPI.Perimeter[],
    start_year?: number,
    end_year?: number
  ): Observable<KPI.RoadmapIndicator[]> {
    const key = UtilsService.getKey(arguments);
    if (!this._roadmapIndicators$[key]) {
      const params = {};
      if (perimeters) {
        params['buildings'] = PerimetersService.getBuildingsIds(perimeters).join(',');
      }
      if (start_year) {
        params['start_year'] = start_year;
      }
      if (end_year) {
        params['end_year'] = end_year;
      }
      return this._roadmapIndicators$[key] = this.api.roadmap_roadmap_indicators(params).pipe(shareReplay(1));
    }
    return this._roadmapIndicators$[key];
  }

  public get chapters$(): Observable<KPI.Chapter[]> {
    if (!this._chapters$) {
      this._chapters$ = this.api.roadmap_chapters(null, true).pipe(shareReplay(1));
    }

    return this._chapters$;
  }

  public getChapterItems$(chapterId: number): Observable<KPI.Item[]> {
    if (!this.items[chapterId]) {
      this.items[chapterId] = this.api.roadmap_items({ chapters: chapterId }, true).pipe(shareReplay(1));
    }

    return this.items[chapterId];
  }
}
